import {Component, Inject, OnInit} from '@angular/core';
import {FeedbackInfo} from '../../models/feedback.model';
import {UserInformationService} from '../../services/user-information.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SupportRequestModel} from '../../models/support-request.model';
import {atLeastOneRequiredValidator} from '../../validators/atLeastOneRequiredValidator.validator';


@Component({
    selector: 'app-feedback-dialog',
    templateUrl: './feedback-dialog.component.html',
    styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent implements OnInit {
    feedbackForm: FormGroup;
    isCaseForm: boolean;

    constructor( public dialogRef: MatDialogRef<FeedbackDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
                 public userInformationService: UserInformationService, private formBuilder: FormBuilder) {
    }

    ngOnInit() {
        this.isCaseForm = this.data.isCaseForm;

        this.feedbackForm = this.formBuilder.group({
            mailFrom: ['', Validators.required],
            mailSubject: ['', Validators.required],
            mailSystemOrComponent: ['', this.isCaseForm ? [] : [Validators.required]],
            caseSystem: [''],
            caseSerial: [''],
            mailBody: ['', [Validators.required, Validators.minLength(40)]],
        }, {
            validators: this.isCaseForm ? atLeastOneRequiredValidator('caseSystem', 'caseSerial') : null
        });

        if (this.userInformationService.loggedIn) {
            this.feedbackForm.get('mailFrom').setValue(this.userInformationService.user.contacts.email);
            if (this.userInformationService.shownEquipment !== null) {
                this.feedbackForm.get('mailSystemOrComponent').setValue(this.userInformationService.shownEquipment);
                this.feedbackForm.get('caseSystem').setValue(this.userInformationService.shownEquipment);
            }
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    getFeedbackData() {
        this.feedbackForm.markAllAsTouched();
        if (this.feedbackForm.valid && !this.isCaseForm) {
            const fb = new FeedbackInfo();
            fb.mailBody = this.feedbackForm.get('mailBody').value;
            fb.mailFrom =  this.feedbackForm.get('mailFrom').value;
            fb.mailSubject = this.feedbackForm.get('mailSubject').value;
            fb.mailSystemOrComponent = this.feedbackForm.get('mailSystemOrComponent').value;
            this.dialogRef.close(fb);
        } else if (this.feedbackForm.valid && this.isCaseForm) {
            const supportRequest: SupportRequestModel = {
                userText: this.feedbackForm.get('mailBody').value,
                text: this.feedbackForm.get('mailBody').value,
                requestor: this.feedbackForm.get('mailFrom').value,
                subject: this.feedbackForm.get('mailSubject').value,
                systemId: this.feedbackForm.get('caseSystem').value,
                serialNumber: this.feedbackForm.get('caseSerial').value
            };
            this.dialogRef.close(supportRequest);
        }
    }
}
